(function defaultScript($, Drupal) {
  Drupal.behaviors.utility_chosen = {
    attach(context) {
      if ($('.pl select:visible').length > 0) {
        $('.pl select:visible').chosen();
      }
    }
  };
})(jQuery, Drupal);